import React, { useState } from 'react'
import moment from 'moment'
import Button from '../../_library/Button'
import ConfirmModal from '../../_library/ConfirmModal'
import DateTimePickerReact from '../../_library/DateTimePickerReact'

const FORMAT = 'YYYY-MM-DD HH:mm'

const Schedule = ({ handleSchedule = () => {}, isDisabled = false, event = {} }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [scheduledDate, setScheduledDate] = useState(null)
  const [scheduledDateError, setScheduledDateError] = useState(null)

  const handleScheduleButtonClick = e => {
    e.preventDefault()
    setIsModalOpen(true)
  }

  const handleScheduleDateChange = date => {
    setScheduledDate(date)
  }

  const handleModalClose = () => {
    setIsModalOpen(false)
    setScheduledDate(null)
  }

  const handleModalConfirm = response => {
    switch (response) {
      case 'ok':
        if (moment(scheduledDate).tz(event.timezone).isSameOrBefore(moment.tz(event.timezone))) {
          setScheduledDateError('Schedule date must be future date/time')
          return
        }

        const formattedDate = moment(scheduledDate).tz(event.timezone).format(FORMAT)

        handleSchedule(formattedDate)
        handleModalClose()
        break
      case 'cancel':
        handleModalClose()
        break
      default:
        break
    }
  }

  return (
    <>
      <Button
        className="btn btn-success btn-lg btn-shadow schedule-btn"
        onClick={handleScheduleButtonClick}
        disabled={isDisabled}
      >
        <span>
          <i className="fa fa-calendar" aria-hidden="true" /> Schedule message
        </span>
      </Button>
      <ConfirmModal
        isOpen={isModalOpen}
        header="Schedule message"
        content={
          <div>
            <DateTimePickerReact
              id="scheduleDate"
              placeholder="D MMM YYYY H:M AM"
              value={scheduledDate}
              onChange={handleScheduleDateChange}
              hint="The timing is based on the event timezone +15 minutes."
              minDate={moment().toDate()}
              error={scheduledDateError}
              touched={true}
            />
          </div>
        }
        actions={[
          {
            value: 'ok',
            label: 'Schedule',
            className: 'btn btn-success btn-shadow',
            disabled: !scheduledDate,
          },
          {
            value: 'cancel',
            label: 'Cancel',
            className: 'btn btn-cancel',
          },
        ]}
        classNames={{
          modal: 'modal-dialog modal-trans modal-medium',
          container: 'modal-dialog schedule-modal-dialog modal-medium',
        }}
        onAction={handleModalConfirm}
      />
    </>
  )
}

export default Schedule
